import React from 'react';
import SocialIcons from './SocialIcons';

function Agent(props){

    let agentImage = null;
    let classNames = "media";
    let agentNameColor = null;
    let socialIcons = null;
    let finalOutput = null;
    let googleMapUrl = "https://maps.google.com/?q=";
    let trimPhoneNumber = null;

    let isMobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent) || ('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
        isMobile = true;
    }

    if(props.info.phone){
        let phoneNumber = props.info.phone;
        trimPhoneNumber = phoneNumber.split('#')[0].replace(/[^0-9\s]/g, '').trim();
    }

    if(props.template === "CROSSBAR"){
        classNames = "media temp23 agent23";

        if(props.agentNameColor){
            agentNameColor = {
                color : props.agentNameColor.color
            }
        }

    }else if(props.template === "CROSSBAR_LEFT"){
        classNames = "media temp25";
    }else if(props.template === "THEATER" ||
    props.template === "THEATER_CONTACT" ||
    props.template === "THEATER_CONTACT_FOOTER" ||
    props.template === "THEATER_FOOTER" ||
    props.template === "NEWSLETTER" ||
    props.template === "NEWSLETTER_FOOTER" ||
    props.template === "TABBED_THEATER" ||
    props.template === "TABBED_THEATER_FOOTER" ||
        props.template === "THEATER_360_FOOTER" ||
        props.template === "THEATER_NO_SOCIAL") {
        socialIcons = <SocialIcons shareurl={props.shareurl} dealerName={props.dealerName} template={props.template} checkTheme={props.backgroundImageVal}/>
    }

    if(props.info.photo){
        agentImage =  <img className="agent-photo img-thumbnail mr-3 mt-3" src={props.info.photo} alt="Agent"/>;
    }else{
        agentImage = null;
    }

    let mediaBodyBgColor = {
        backgroundColor:(props.backgroundImageVal && props.backgroundImageVal.backgroundImage) ? props.backgroundImageVal.mediaBodybg : ''
    }

    if(props.preview){

        let agentName = props.info.name;
        agentName = agentName.trim();
        let agentCompany = null;
        let agentAddress = null;
        let agentCity = null;
        let agentState = null;
        let agentZip = null;
        let agentPhone = null;
        let agentEmail = null;

        if(agentName){
            agentName = <div style={agentNameColor} className="agent-name">{props.info.name}</div>
        }else{
            agentName = <div style={agentNameColor} className="agent-name-missing">{props.info.name_missing}</div>
        }

        if(props.info.company){
            agentCompany = <div>{props.info.company}</div>
        }else{
            agentCompany = <div className="agent-company-missing" >{props.info.company_missing}</div>
        }

        if(props.info.address){
            agentAddress = <div>{props.info.address}</div>
        }else{
            agentAddress = <div className="agent-address-missing" >{props.info.address_missing}<br/></div>
        }

        if(props.info.city){
            agentCity = <span>{props.info.city}, </span>
        }else{
            agentCity = <div className="agent-city-missing" >{props.info.city_missing} </div>
        }

        if(props.info.state){
          agentState = <span>{props.info.state} </span>
        }else{
           agentState =  <div className="agent-state-missing" >{props.info.state_missing} </div>
        }

        if(props.info.zip){
           agentZip = <span>{props.info.zip} </span>
        }else{
           agentZip = <div className="agent-zip-missing" >{props.info.zip_missing} </div>
        }

        if (props.info.email && props.template == 'THEATER_NO_SOCIAL') {
            let queryString = props.shareurl.split('?')[1];
            let mailBody;

            if (!queryString || queryString.trim() === '') {
                mailBody = `Video URL: ${encodeURIComponent(props.shareurl)}video_fkey=${props.video_fk}`;
            } else {
                mailBody = `Video URL: ${encodeURIComponent(props.shareurl)}`;
            }
            agentEmail = <a style={{ color: '#007bff', textDecoration: 'underline' }} href={`mailto:${props.info.email}?subject=Checkout%20This%20Vehicle&body=${mailBody}`}>{props.info.email}</a>;
        } else {
            agentEmail = '';
        }

        if(props.info.phone){
            agentPhone = <div style={{marginTop:"3px"}}>{isMobile ? <a style={{color:'inherit',textDecoration:'none'}} href={"tel:" + trimPhoneNumber}>{props.info.phone}</a> : props.info.phone}</div>

            if(props.template == 'LP_LINKS_WITH_ICONS'){
                agentPhone = <div style={{marginTop:"3px"}}>{isMobile ? <a style={{color:'inherit',textDecoration:'underline'}} href={"tel:" + trimPhoneNumber}>{props.info.phone}</a> : props.info.phone}</div>
            }

            if (props.template == 'THEATER_NO_SOCIAL') {
                agentPhone = <div style={{ marginTop: "3px" }}>{isMobile ? <a style={{ color: '#007bff', textDecoration: 'underline' }} href={"tel:" +trimPhoneNumber}>{props.info.phone}</a> : props.info.phone}</div>
            }
        }else{
            agentPhone = <div className="agent-phone-missing" >{props.info.phone_missing}</div>
        }

        finalOutput = <div style={props.styles} className={classNames} id="agent-box">
            {agentImage}
                <div className="media-body agent-info" style={mediaBodyBgColor}>
                    {agentName}  
                    {agentCompany}       
                    {agentAddress}      
                    {agentCity}     
                    {agentState}  
                    {agentZip}  
                    {agentPhone}                   
                    <div>{socialIcons} </div>       
            </div>
        </div>

        if(props.template == 'LP_LINKS_WITH_ICONS'){
            finalOutput = (
            <div style={props.styles} className={classNames} id="agent-box">
                {agentImage}
                <div className="media-body agent-info" style={mediaBodyBgColor}>
                    {agentName}
                    {agentCompany}
                    <a target="_blank" style={{ color: "inherit", textDecoration: "underline" }} href={(props.info.address ? (googleMapUrl + (props.info.address + " ") + (props.info.city + " ") + (props.info.state + " ") + props.info.zip) : "")}>
                        {agentAddress}
                        {agentCity}
                        {agentState}
                        {agentZip}
                    </a>
                    {agentPhone}
                    <div>{socialIcons} </div>
                </div>
            </div>
        );
        }

        if (props.template == 'THEATER_NO_SOCIAL') {
            finalOutput = <div style={props.styles} className={classNames} id="agent-box">
                {agentImage}
                <div className="media-body agent-info" style={mediaBodyBgColor}>
                    {agentName}
                    {agentCompany}
                    {agentAddress}
                    {agentCity}
                    {agentState}
                    {agentZip}
                    {agentPhone}
                    <div>{agentEmail} </div>
                </div>
            </div>
        }
    }else{
        //props.info.city = null;
        //props.info.state = null;
        let comma = (props.info.city && props.info.state) ? ", " : '';
        finalOutput = <div style={props.styles} className={classNames} id="agent-box">{agentImage}
        <div className="media-body agent-info" style={mediaBodyBgColor}>
            <div style={agentNameColor} className="agent-name">{props.info.name}</div>
            <div>{props.info.company}</div>
            <div>{props.info.address}</div>
            <div>{props.info.address2}</div>            
            <div>{props.info.city}{comma} {props.info.state} {props.info.zip}</div>

            <div style={{marginTop:"3px"}}>{isMobile ? <a style={{color:'inherit',textDecoration:(props.template == 'LP_LINKS_WITH_ICONS' ? 'underline': 'none')}} href={"tel:" + trimPhoneNumber}>{props.info.phone}</a> : props.info.phone}</div>
            <div>{socialIcons} </div>
        </div>
    </div>;

    if(props.template == 'LP_LINKS_WITH_ICONS'){
        finalOutput = (
            <div style={props.styles} className={classNames} id="agent-box">
                {agentImage}
                <div className="media-body agent-info" style={mediaBodyBgColor}>
                    <div style={agentNameColor} className="agent-name">{props.info.name}</div>
                    <div>{props.info.company}</div>
                    <a target="_blank" style={{ color: "inherit", textDecoration: "underline" }} href={
                            googleMapUrl + props.info.address + " " + (props.info.address2 ? props.info.address2 : "") + props.info.city + comma + props.info.state + " " + props.info.zip}>
                        <div>{props.info.address}</div>
                        <div>{props.info.address2}</div>
                        <div>{props.info.city}{comma} {props.info.state} {props.info.zip}</div>
                    </a>
                    <div style={{marginTop:"3px"}}>{isMobile ? (<a style={{ color: "inherit", textDecoration: "underline" }} href={"tel:" + trimPhoneNumber}>{props.info.phone}</a>) : (props.info.phone)}
                    </div>
                    <div>{socialIcons} </div>
                </div>
            </div>
        );

        }

        if (props.template == 'THEATER_NO_SOCIAL') {
            let queryString = props.shareurl.split('?')[1];
            let mailBody;

            if (!queryString || queryString.trim() === '') {
                mailBody = `Video URL: ${encodeURIComponent(props.shareurl)}video_fkey=${props.video_fk}`;
            } else {
                mailBody = `Video URL: ${encodeURIComponent(props.shareurl)}`;
            }

            let comma = (props.info.city && props.info.state) ? ", " : '';
            finalOutput = <div style={props.styles} className={classNames} id="agent-box">{agentImage}
                <div className="media-body agent-info" style={mediaBodyBgColor}>
                    <div style={agentNameColor} className="agent-name">{props.info.name}</div>
                    <div>{props.info.company}</div>
                    <div>{props.info.address}</div>
                    <div>{props.info.address2}</div>
                    <div>{props.info.city}{comma} {props.info.state} {props.info.zip}</div>

                    <div style={{ marginTop: "3px" }}>{isMobile ? <a style={{ color: '#007bff', textDecoration: 'underline' }} href={"tel:" + trimPhoneNumber}>{props.info.phone}</a> : props.info.phone}</div>
                    <a style={{ color: '#007bff', textDecoration: 'underline' }} href={`mailto:${props.info.email}?subject=Checkout%20This%20Vehicle&body=${mailBody}`}>{props.info.email}</a>
                </div>
            </div>;
    }
  }

    return( finalOutput );
}

export default Agent;


// WEBPACK FOOTER //
// ./src/components/Agent.js